import { render, staticRenderFns } from "./JGisMapSwitching.vue?vue&type=template&id=136ef905"
import script from "./JGisMapSwitching.vue?vue&type=script&lang=js"
export * from "./JGisMapSwitching.vue?vue&type=script&lang=js"
import style0 from "./JGisMapSwitching.vue?vue&type=style&index=0&id=136ef905&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports